import sortBy from 'lodash-es/sortBy';
import { IColumnSelection } from '../types';
import { DisbursementTableRow } from './buildDisbursementsData';
import { DisputeTableRow } from './buildDisputesData';
import { TransactionTableRow } from './buildTransactionsData';

export type CSVRow = DisbursementTableRow | Partial<TransactionTableRow> | Partial<DisputeTableRow>;

export const convertArrayOfObjectsToCSV = ({
  array,
  columns,
}: {
  array: CSVRow[];
  columns: IColumnSelection[];
}): string => {
  let result = '';

  const columnDelimiter = ',';
  const lineDelimiter = '\n';

  const keys = Object.keys(array[0] || []);

  const columnSelectors = columns.map((c) => c.selector);
  const sortedKeys = sortBy(keys, (key) => {
    return columnSelectors.indexOf(key);
  });

  const columnNames = sortedKeys.map((key) => {
    for (const column of columns) {
      if (key === column.selector) {
        return column.name;
      }
    }

    return key;
  });

  result += columnNames.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach((item: CSVRow) => {
    let ctr = 0;
    sortedKeys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key as keyof CSVRow];

      ctr++;
    });
    result += lineDelimiter;
  });

  return result;
};
